import React from "react";
import { Typography } from 'antd';
const { Text, Paragraph, Title } = Typography;

function KoText(props) {
  const { text } = props;
  return (
    <Text {...props}>{text}</Text>

  );
}


function KoDescription(props) {
  const { text } = props;
  return (
    <Paragraph {...props}>
      {text}
    </Paragraph>

  );
}

function KoTitle(props) {
  const { text,  level} = props;
  return (
    <Title {...props} level={level}>{text}</Title>
  );
}

export {KoText, KoDescription, KoTitle};